import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = 126
// module chunks = 75